(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/router.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.spelpaus.Router = svs.app.ServerSideHelper.ServerSideRouterDecorator.decorate({
    initialize: function initialize() {
      svs.spelpaus.logger.debug('svs.spelpaus.router.View initialize');
      this.setDefaultRegion(svs.spelpaus.app.getRegion());
    },
    routes: svs.core.data.routes,
    navigateIfRoute: function navigateIfRoute(route) {
      if (route) {
        route = route.substring(1);

        if (this.routes[route]) {
          this.navigate(route, true);
        } else {
          svs.transactions.logger.warn("Got navigation request for nonexisting route: ".concat(route, ", ignoring."));
        }
      }
    },
    start: function start() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        this.showView(svs.spelpaus.views.Start);
      } else {
        this.showView(svs.spelpaus.views.StartUninlogged);
      }
    },
    suspension: function suspension() {
      var _this = this;

      this.showView(svs.spelpaus.views.Suspension, {
        model: new svs.spelpaus.models.SuspensionOverview(svs.spelpaus.data.suspensionoverview, {
          parse: true
        }),
        pageTitle: 'Spelpaus',
        backLinkText: 'Spelpaus start',
        backLinkUrl: '/spelpaus',
        backLink: '/spelpaus',
        onNavigation: function onNavigation(route) {
          _this.navigateIfRoute(route);
        }
      });
      this.handleHeaderAndNavigation('Spelpaus');
    },
    handleHeaderAndNavigation: function handleHeaderAndNavigation(pageTitle) {
      if (svs.core.detect.formfactor.mobile() || svs.core.detect.breakpoint.equals('xs')) {
        svs.core.template.updateConfig({
          title: {
            row1: {
              text: pageTitle ? pageTitle : 'Spelpaus'
            }
          }
        }); 

        pageTitle ? svs.components.navigation.hideHamburger() : svs.components.navigation.showHamburger();
      }

      $(document).scrollTop(0);
    }
  });
})(Backbone, _, svs);
 })(window);